import React from 'react'
import styled from 'styled-components'
import { OperationsData } from '../'

const OperationsDept = ({department, desc, list1, list2, list3, list4, link}) => {
  return (
    <Container>
        <h3>{department}</h3>
        <h4>{desc}</h4>


        <ol>
            <li>{list1}</li>
            <li>{list2}</li>
            <li>{list3}</li>
            <li>{list4}</li>
        </ol>

        <a href={link}>Read more</a>
    </Container>
  )
}

const Container = styled.section`
    padding: 24px;
    margin-top: 24px;
    border: 1px solid #D0D5DD;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.15), 0px 4px 6px rgba(255, 255, 255, 0.25);
    background: #FFFFFF;
    border-radius: 4px;

    & h4{
        color: #667085;
        font-size: 16px;
    }

    & ol{

        color: #667085;
        padding-left: 24px;
        margin-bottom: 35px;

        & li{
            /* padding-left: 24px; */
            color: #667085;
            font-size: 16px;
        }
    }

    & a{
        color: #fff;
        font-size: 16px;
        background-color: #2A870E;;
        padding: 15px 26px;
        border-radius: 4px;
        
    }
`

export {OperationsDept}